import {
    QueryClient,
    useMutation,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryResult
} from '@tanstack/react-query';

import { IncomeSourceModel } from 'src/types/income-source.model';
import IncomeSourceService, { UpsertIncomeParams } from 'src/services/income-source.service';
import { invalidateUser } from 'src/hooks/queries/users';

const queryKey = 'incomes';

export const useIncomes = (): UseQueryResult<IncomeSourceModel[]> => {
    return useQuery<IncomeSourceModel[]>({
        queryKey: [queryKey],
        queryFn: async () => await IncomeSourceService.getIncomeSources()
    });
};

export const useCreateIncome = (): UseMutationResult<IncomeSourceModel, unknown, string> => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (incomeSourceName: string) => {
            const newIncome: IncomeSourceModel = new IncomeSourceModel();
            newIncome.name = incomeSourceName;
            return await IncomeSourceService.createIncomeSource(newIncome);
        },
        onSuccess: (): void => {
            void invalidateIncomes(queryClient);
        }
    });
};

export const useUpsertIncome = (): UseMutationResult<void, unknown, UpsertIncomeParams> => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ user, amount, existingIncome, nonTaxIncome }: UpsertIncomeParams) => {
            return await IncomeSourceService.upsertIncome({ user, amount, existingIncome, nonTaxIncome });
        },
        onSuccess: (): void => {
            void invalidateIncomes(queryClient);
            void invalidateUser(queryClient);
        }
    });
};

export const invalidateIncomes = async (queryClient: QueryClient): Promise<void> => {
    await queryClient.invalidateQueries([queryKey]);
};
